import { Flex, Heading, useToast } from '@chakra-ui/react'

import { UserEditForm } from './UserEditForm'
import type { DetailedUser, EditUser, ModelState, UserProperties } from 'BrokerTsLib/src/dtos'
import { BadRequestError } from 'BrokerTsLib/src/dtos'
import { useUpdateUser } from 'BrokerTsLib/src/hooks/useUser'
import { useNavigate } from 'react-router'
import type { AxiosError } from 'axios'
import { useGetOrganizationUnitById } from 'brokertslib/src/hooks/useOrganizationUnit'

export const UserEdit = ({ user, properties }: { user: DetailedUser, properties: UserProperties }) => {
  const navigate = useNavigate()
  const toast = useToast()
  const { mutateAsync: updateUser } = useUpdateUser(user.userId)
  const { data } = useGetOrganizationUnitById(user.organizationUnitId)

  const onSubmit = async (values: EditUser) => {
    const result = await updateUser(values)
      .then(() => {
        navigate(`/user/${user.userId}`)
      })
      .catch((e: AxiosError) => {
        toast({
          title: 'Chyba při vytváření uživatele',
          description: `${e.response?.status}: ${e.response?.statusText}`,
          status: 'error',
        })

        if (e.status === 400)
          return new BadRequestError(e.response?.data as ModelState<EditUser>)

        return e.cause as Error
      })
    return result
  }

  return (
    <Flex sx={{ flexDirection: 'column', gap: 6 }}>
      <Heading>Upravit uživatele</Heading>

      {data?.data && <UserEditForm user={user} properties={properties} onSubmit={onSubmit} organization={data?.data} />}
    </Flex>
  )
}
